import { render, staticRenderFns } from "./DomainEdit.vue?vue&type=template&id=6c38a7f6&"
import script from "./DomainEdit.vue?vue&type=script&lang=js&"
export * from "./DomainEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports